module.exports = __webpack_public_path__ + "media/flags/006-turkey-f8a06d7b.svg";